import { Theme, css } from '@emotion/react';

export const drawerTitleStyles = ({ colors, spacing }: Theme) => css`
  align-items: center;
  border-bottom: 1px solid ${colors.borderDefault};
  display: flex;
  flex-flow: row wrap;
  min-height: 6rem;
  padding: ${spacing(1.5)}px ${spacing(2)}px;
`;

export const drawerTitleTextStyles = css`
  flex: 1;
`;

export const drawerTitleActionStyles = ({ spacing }: Theme) => css`
  margin-left: ${spacing(3)}px;
`;

export const drawerTitleCloseStyles = ({ colors, spacing }: Theme) => css`
  margin-right: ${spacing(-0.5)}px;
`;
